import { useEffect } from "react";
import { useState } from "react";

export default function Avatar({
  firstName,
  lastName,
  avatarImageUrl,
}: {
  firstName?: string;
  lastName?: string;
  avatarImageUrl?: string;
}) {
  const [avatarImage, setAvatarImage] = useState<string | null>(null);

  useEffect(() => {
    if (avatarImageUrl) {
      setAvatarImage(avatarImageUrl);
    }
  }, [avatarImageUrl]);

  // Cleanup the object URL when component unmounts
  useEffect(() => {
    return () => {
      if (
        avatarImage &&
        avatarImage.startsWith("blob:") &&
        avatarImage !== avatarImageUrl
      ) {
        URL.revokeObjectURL(avatarImage);
      }
    };
  }, [avatarImage, avatarImageUrl]);

  return (
    <div className="flex items-center">
      <div
        className="bg-[#78C7D1] text-white rounded-full w-9 h-9 flex items-center justify-center overflow-hidden"
        style={avatarImage ? { padding: 0 } : undefined}
      >
        {avatarImage ? (
          <img
            src={avatarImage}
            alt={`${firstName} ${lastName}`}
            className="w-full h-full object-cover"
          />
        ) : (
          `${firstName?.[0]}${lastName?.[0]}`.toUpperCase()
        )}
      </div>
      <div className="ml-3">
        <p className="text-gray-900">
          {firstName ?? ""} {lastName ?? ""}
        </p>
      </div>
    </div>
  );
}
